// @mui
import { SvgIcon } from "@mui/material";

function SearchIcon(props) {
  return (
    <SvgIcon
      width="16px"
      height="16px"
      viewBox="0 0 24 24"
      sx={{
        fill: "transparent",
      }}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g
        id="Iconly/Light/Search"
        stroke={props?.color || "#000"}
        strokeWidth="1.5"
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <g id="Search" transform="translate(2.000000, 2.000000)" stroke={props?.color || "#000"} strokeWidth="1.5">
          <circle id="Ellipse_739" cx="9.76659044" cy="9.76659044" r="8.9885584"></circle>
          <line x1="16.0183067" y1="16.4851259" x2="19.5423342" y2="20.0000001" id="Line_181"></line>
        </g>
      </g>
    </SvgIcon>
  );
}

export default SearchIcon;
